import React from 'react';
import HelpContent from './HelpContent';
//import proyeccionParticipacion from 'img/proyeccion_participacion.png';

const ReglamentacionTermicaViviendasHelp = () => (
  <HelpContent>
    <h1>Aumento de la Reglamentacion Termica Viviendas</h1>
    <p>
    Esta medida consiste en aumentar la exigencia de la reglamentación térmica de las viviendas nuevas. La envolvente térmica consiste en una serie de 
    elementos constructivos a través de los cuales se produce el flujo térmico entre el ambiente interior y el ambiente exterior del edificio. 
    Está constituida básicamente por los complejos de techumbre, muros, pisos y ventanas. Edificar de manera sustentable, por medio de la incorporación 
    de estándares de sustentabilidad en el diseño, construcción y reacondicionamiento de edificaciones, a fin de minimizar los requerimientos energéticos
    y las externalidades ambientales a lo largo de su ciclo de vida, alcanzando niveles adecuados de confort.
    </p>
    <p>
    De acuerdo a la Política Energética de largo plazo, se espera que para 2050 el 100% de las edificaciones nuevas cumple con el estándar de 
    sustentabilidad y de confort y se alcanza una meta (establecida en un plan de reacondicionamiento) para edificaciones existentes.
    </p>

    <p>
    <strong>Trayectoria 1:</strong>
    </p>

    <p>
    Reglamentación térmica:  se modela como una reducción de la demanda de energía útil de calefacción. 
    La actualización de la RT en 2025 implica 1.363.000  viviendas con RT2025 en 2035 y actualización de la RT en 2035 implica 1.595.000 viviendas con RT2035 en 2050.
    </p>

    <p>
    Reacondicionamiento térmico: se mejora la eficiencia energetica en viviendas existentes, 190.000 viviendas en el periodo 2025-2035 y 680.000 viviendas entre 2035 y 2050. 
    </p>

  </HelpContent>
);

export default ReglamentacionTermicaViviendasHelp;
